import { PriceModel } from './Price.model';
import { ModelContext } from './ModelContext';
import { CatalogReferenceModel } from './CatalogReference.model';
import { cartV2 } from '@wix/ecom';

export class LineItemModel {
  public id: string;
  public membersOnly: boolean;
  public hasPolicies: boolean;
  public catalogReference?: CatalogReferenceModel;
  public salePrice?: PriceModel;
  public unitPrice?: PriceModel;
  public totalPrice?: PriceModel;
  public confirmedQuantity?: number;
  public name: string;
  public description: string;
  public shippable: boolean;

  constructor(lineItemModel: LineItemModel) {
    this.id = lineItemModel.id;
    this.membersOnly = lineItemModel.membersOnly;
    this.catalogReference = lineItemModel.catalogReference;
    this.salePrice = lineItemModel.salePrice;
    this.unitPrice = lineItemModel.unitPrice;
    this.totalPrice = lineItemModel.totalPrice;
    this.confirmedQuantity = lineItemModel.confirmedQuantity;
    this.name = lineItemModel.name;
    this.description = lineItemModel.description;
    this.hasPolicies = lineItemModel.hasPolicies;
    this.shippable = lineItemModel.shippable;
  }

  public static fromV2(
    lineItem: cartV2.V2LineItem,
    modelContext: ModelContext,
  ) {
    return new LineItemModel({
      id: lineItem._id!,
      membersOnly: Boolean(lineItem.attributes?.membersOnly),
      catalogReference: CatalogReferenceModel.fromV2(
        lineItem.source?.catalogReference,
      ),
      salePrice: PriceModel.fromV2(
        lineItem.pricing?.breakdown?.salePrice,
        modelContext,
      ),
      unitPrice: PriceModel.fromV2(lineItem.pricing?.unitPrice, modelContext),
      totalPrice: PriceModel.fromV2(lineItem.pricing?.totalPrice, modelContext),
      confirmedQuantity: lineItem.quantityInfo?.confirmedQuantity,
      name: lineItem.name?.translated ?? lineItem.name?.original ?? '',
      description: getDescription(lineItem.attributes?.descriptionLines),
      hasPolicies: hasPolicies(lineItem.attributes?.policies),
      shippable: Boolean(lineItem.attributes?.physicalProperties?.shippable),
    });
  }
}

function getDescription(
  descriptionLines?: {
    name?: { original?: string | null; translated?: string | null };
    plainText?: { original?: string | null; translated?: string | null };
    colorInfo?: { original?: string | null; translated?: string | null };
  }[],
) {
  return (
    descriptionLines?.reduce((acc, descriptionLine) => {
      acc = acc !== '' ? `${acc} |` : acc;
      return `${acc} ${
        descriptionLine.name?.translated ??
        /* istanbul ignore next */ descriptionLine.name?.original
      }: ${
        descriptionLine.plainText?.translated ??
        descriptionLine.plainText?.original ??
        descriptionLine.colorInfo?.translated ??
        descriptionLine.colorInfo?.original
      }`;
    }, '') ?? ''
  );
}

function hasPolicies(policies?: {}[]) {
  return Boolean(policies && policies.length > 0);
}
